export class ZoneDeptRelation {

  zone: string;

  color: string;

  name: string;

  code: string;

  description: string;

  id: number;

  zoneType: ZoneType;
}

export class ZoneType {

  zoneTypeCode: string;
  name: string;
  description: string;
  id: string;

  idZone: string;
  codeZone: string;
  storeId: string;

  zoneProperties: ZoneProperties[];


  constructor(name?: string, id?: string, code?: string, storeId?: string) {
    this.name = name;
    this.id = id;
    this.codeZone = code;
    this.storeId = storeId;
  }
}

/**
 *
 */
export class VizixZone {
  public serialNumber: string;
  public StoreID: string;
  public StoreName: string;
  public Department: string;
  public ZonePickList: string[];
  public ZoneTypeCode: string[];
  public ZoneTypeID: string[];
  public All: boolean;

  constructor(serialNumber: string,
              StoreID: string,
              StoreName: string,
              Department: string,
              ZonePickList: string | string[],
              ZoneTypeCode: string | string[],
              ZoneTypeID: string | string[],
              All: boolean) {

    this.serialNumber = serialNumber;
    this.StoreID = StoreID;
    this.StoreName = StoreName;
    this.Department = Department;

    if (typeof ZonePickList == 'string') {
      this.ZonePickList = ZonePickList.split('|');
    } else {
      this.ZonePickList = ZonePickList;
    }
    if (typeof ZoneTypeCode == 'string') {
      this.ZoneTypeCode = ZoneTypeCode.split('|');
    } else {
      this.ZoneTypeCode = ZoneTypeCode;
    }
    if (typeof ZoneTypeID == 'string') {
      this.ZoneTypeID = ZoneTypeID.split('|');
    } else {
      this.ZoneTypeID = ZoneTypeID;
    }

    this.All = All;
  }

  public getIncludedZones(): VizixZone[] {
    let vizixZoneList: VizixZone[] = [];
    if (this.ZonePickList.length > 0 &&
      this.ZoneTypeCode.length > 0 &&
      this.ZoneTypeID.length > 0 &&
      this.ZonePickList.length == this.ZoneTypeCode.length &&
      this.ZoneTypeCode.length == this.ZoneTypeID.length) {
      for (let i = 0; i < this.ZonePickList.length; i++) {
        vizixZoneList.push(this.get(i));
      }
    }
    return vizixZoneList;
  }

  public get(index: number): VizixZone {
    if (index < this.ZonePickList.length &&
      index < this.ZoneTypeCode.length &&
      index < this.ZoneTypeID.length) {
      return new VizixZone(this.serialNumber,
        this.StoreID,
        this.StoreName,
        this.Department,
        this.ZonePickList[index],
        this.ZoneTypeCode[index],
        this.ZoneTypeID[index],
        this.All);
    } else {
      console.error('VizixZone index out of bounds! Check Zones');
      return new VizixZone(this.serialNumber,
        this.StoreID,
        this.StoreName,
        this.Department,
        this.ZonePickList,
        this.ZoneTypeCode,
        this.ZoneTypeID,
        this.All);
    }
  }
}

export class DepartmentsZones {
  public DeptName: string;
  public DeptId: string;
  public ALL: boolean;
  public Zones: ZoneType[];

  constructor(DeptName?: string, Code?: string, Zones?: ZoneType[], All?: boolean) {
    this.DeptName = DeptName;
    this.DeptId = Code;
    this.ALL = All;
    this.Zones = Zones;
  }
}

export class ZoneProperties {
  public name: string;
  public id: number;
  public type: number;
  public value: boolean;
}



// WEBPACK FOOTER //
// ./src/models/zoneDeptRelation.ts